import React from "react"
import "./Logo.scss"
import image from "./Logo.svg"

const Logo = () => {
  return (
    <div className="Logo">
      <img alt="SwipeSense Logo" src={image} />
    </div>
  )
}

export default Logo
